<template>
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout ?? 4000"
    :color="snackbar.color ?? 'primary'"
    :bottom="snackbar.bottom ?? false"
    :top="snackbar.top ?? true"
    :left="snackbar.left ?? false"
    :right="snackbar.right ?? false"
    :outlined="snackbar.outline ?? false"
    :rounded="snackbar.rounded ?? 'lg'"
    :multi-line="snackbar.multiLine ?? false"
    @input="val => {
      if (!val) close();
    }"
  >
    <div class="d-flex align-center">
      <v-icon v-if="snackbar.icon" class="mr-2">
        {{ snackbar.icon }}
      </v-icon>

      <span>{{ snackbar.text }}</span>
    </div>

    <template #action="{attrs}">
      <v-btn
        icon
        v-bind="attrs"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">

// libs.
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Snackbar',
  computed: {
    ...mapGetters([
      'snackbar',
    ]),
  },
  methods: {
    ...mapActions([
      'updateSnackbar',
    ]),
    close() {
      this.updateSnackbar({ ...this.snackbar, show: false });
    },
  },
};
</script>
